import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { CustomListDefinitionModel } from '../../../model/custom-lists/custom-list-definition.model';
import { ISaveCustomListPayload } from '../../../action/custom-lists.action';

export const saveCustomListDefinition = (customList: CustomListDefinitionModel) => returnAction<ISaveCustomListPayload>(ActionEnum.SAVE_CUSTOM_LIST_DEFINITION, {listDefinition: customList});
